var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notification-card",
      class: { seen: _vm.notification.seen },
    },
    [
      _c("ActivityCard", {
        attrs: { activity: _vm.notification.activity, "show-date": false },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "metas" }, [
        _c("span", { staticClass: "date" }, [
          _vm._v(_vm._s(_vm.$moment(_vm.notification.createdAt).fromNow())),
        ]),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: {
                followCursor: false,
                placement: "left",
              },
              expression:
                "{\n                followCursor: false,\n                placement: 'left',\n            }",
            },
          ],
          staticClass: "mark-read",
          class: { seen: _vm.notification.seen },
          attrs: { content: "Mark as Read" },
          on: { click: _vm.notificationSeen },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }